import classnames from 'classnames';
import React from 'react';
import Table from '../../dashboard/TookiTakiTable/Table';
import style from './index.scss';
import CollapsibleComponent from './CollapsibleComponent';
import TableRow from '../../dashboard/TookiTakiTable/TableRows/TableRow';
import NoDataToDisplay from '../../../../components/NoDataToDisplay';
import {
  AlertHistoryHeader,
  CustomerActivityHeaderFirstPage,
  CustomerActivityHeaderSecondPage,
  excludedObjectForStyle,
  getProcessedData,
  IN_DATA_ORDER_MAP,
  OUT_DATA_ORDER_MAP
} from './customerActivityUtil';

/**
 * CustomerActivity component
 */
class CustomerActivity extends React.Component {
  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      inData: [],
      outData: [],
      netAmountData: [],
      ratioData: [],
      transactionTypes: null,
      inTransactionExpanded: false,
      outTransactionExpanded: false,
      panelsExpanded: [],

      // column pagination
      columnOffset: 0
    };
  }

  /**
   * componentWillReceiveProps
   * @param nextProps
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.transactionTypes) {
      this.setState({ transactionTypes: nextProps.transactionTypes });
    }
    if (Object.keys(nextProps.data).length !== 0) {
      try {
        const txtTypeData = JSON.parse(nextProps.data.activityDetailsTxnByType);
        const inData = txtTypeData.filter(
          (obj) => obj.componentName === 'IN'
        )?.[0];
        const outData = txtTypeData.filter(
          (obj) => obj.componentName === 'OUT'
        )?.[0];
        const ratioData = txtTypeData.filter(
          (obj) => obj.componentName === 'RATIO'
        )?.[0];
        const netAmountData = txtTypeData.filter(
          (obj) => obj.componentName === 'NET_AMOUNT'
        )?.[0];

        const inDataObject = getProcessedData(
          inData?.componentDetails,
          this.state.transactionTypes,
          IN_DATA_ORDER_MAP
        );
        const outDataObject = getProcessedData(
          outData?.componentDetails,
          this.state.transactionTypes,
          OUT_DATA_ORDER_MAP
        );

        const ratioDataObject = getProcessedData(
          ratioData?.componentDetails,
          this.state.transactionTypes
        );
        const netAmountDataObject = getProcessedData(
          netAmountData?.componentDetails,
          this.state.transactionTypes
        );
        this.setState({
          inData: inDataObject,
          outData: outDataObject,
          ratioData: ratioDataObject,
          netAmountData: netAmountDataObject
        });
      } catch (e) {
        console.log('Exception Error Logs: ', e);
      }
    }
  }

  onClickNextPeriod = () => {
    this.setState({
      columnOffset: 1
    });
  };

  onClickPreviousPeriod = () => {
    this.setState({
      columnOffset: 0
    });
  };

  /**
   * isCCExpanded
   * @param indexExpanded
   */
  isCCExpanded = (indexExpanded) => {
    if (indexExpanded === 0) {
      this.setState({
        inTransactionExpanded: !this.state.inTransactionExpanded
      });
    }
    if (indexExpanded === 1) {
      this.setState({
        outTransactionExpanded: !this.state.outTransactionExpanded
      });
    }
  };

  isCollapsiblePanelExpanded = (indexExpanded) => {
    const { panelsExpanded } = this.state;
    if (panelsExpanded.filter((index) => indexExpanded === index).length > 0) {
      this.setState({
        panelsExpanded: panelsExpanded.filter(
          (index) => indexExpanded !== index
        )
      });
    } else {
      this.setState({ panelsExpanded: [...panelsExpanded, indexExpanded] });
    }
  };

  renderRows = () => {
    const {
      columnOffset,
      inData,
      outData,
      inTransactionExpanded,
      outTransactionExpanded,
      ratioData,
      netAmountData
    } = this.state;
    const { alertDetail } = this.props;
    const inDataComponent =
      inData.length > 0 &&
      inTransactionExpanded &&
      inData.map((tableRow) => {
        return (
          <TableRow
            offset={columnOffset}
            associatedObject={alertDetail}
            isClickableRow={true}
            keys={
              columnOffset === 0
                ? CustomerActivityHeaderFirstPage
                : [
                    ...CustomerActivityHeaderFirstPage,
                    ...CustomerActivityHeaderSecondPage
                  ]
            }
            excludedObjectForStyle={excludedObjectForStyle}
            tableRowData={tableRow}
            inOut="in"
          />
        );
      });
    const outDataComponent =
      outData.length > 0 &&
      outTransactionExpanded &&
      outData.map((tableRow) => {
        return (
          <TableRow
            offset={columnOffset}
            associatedObject={alertDetail}
            isClickableRow={true}
            keys={
              columnOffset === 0
                ? CustomerActivityHeaderFirstPage
                : [
                    ...CustomerActivityHeaderFirstPage,
                    ...CustomerActivityHeaderSecondPage
                  ]
            }
            excludedObjectForStyle={excludedObjectForStyle}
            tableRowData={tableRow}
            inOut="out"
          />
        );
      });

    const netAmountComponent =
      netAmountData.length > 0 &&
      netAmountData.map((tableRow) => {
        return (
          <TableRow
            associatedObject={alertDetail}
            isClickableRow={false}
            keys={
              columnOffset === 0
                ? CustomerActivityHeaderFirstPage
                : [
                    ...CustomerActivityHeaderFirstPage,
                    ...CustomerActivityHeaderSecondPage
                  ]
            }
            excludedObjectForStyle={excludedObjectForStyle}
            tableRowData={tableRow}
          />
        );
      });

    const ratioDataComponent =
      ratioData.length > 0 &&
      ratioData.map((tableRow) => {
        return (
          <TableRow
            associatedObject={alertDetail}
            isClickableRow={false}
            nanHandler={'string'}
            keys={
              columnOffset === 0
                ? CustomerActivityHeaderFirstPage
                : [
                    ...CustomerActivityHeaderFirstPage,
                    ...CustomerActivityHeaderSecondPage
                  ]
            }
            excludedObjectForStyle={excludedObjectForStyle}
            tableRowData={tableRow}
          />
        );
      });

    return [
      <CollapsibleComponent
        index={0}
        title={'In Transaction'}
        data={inData}
        isExpanded={this.isCCExpanded}
        isFixHeader={true}>
        {inData.length === 0 && <NoDataToDisplay />}
      </CollapsibleComponent>,
      inDataComponent,
      <CollapsibleComponent
        index={1}
        title={'Out Transaction'}
        data={outData}
        isExpanded={this.isCCExpanded}
        isFixHeader={true}>
        {outData.length === 0 && <NoDataToDisplay />}
      </CollapsibleComponent>,
      outDataComponent,
      netAmountComponent,
      ratioDataComponent
    ];
  };

  /**
   * render
   * @returns {div}
   */
  render() {
    const { columnOffset } = this.state;

    let sectionHeader = (
      <div className={classnames('row', style.primaryTableHead)}>
        <div className="col-md-10">
          <span className={style.assocTitle}>Customer Activity</span>
        </div>
        <div className="col-md-2">
          <div style={{ display: 'inline-block' }}>
            {columnOffset !== 0 && (
              <div
                onClick={this.onClickPreviousPeriod}
                className={style.headerButtons}>
                <i className="fa fa-angle-left" />
              </div>
            )}
            <div
              onClick={this.onClickNextPeriod}
              className={style.headerButtons}>
              <i className="fa fa-angle-right" />
            </div>
          </div>
        </div>
      </div>
    );

    let renderedView = (
      <div className={classnames(style.card, 'mt-3')}>
        <div className={classnames(style.sectionHeader)}>{sectionHeader}</div>
        <div></div>
        <div className={classnames(style.card_body)}>
          <Table isStriped={true} isFixedColumn={columnOffset !== 0}>
            <AlertHistoryHeader offset={columnOffset} />
            <tbody>{this.renderRows()}</tbody>
          </Table>
        </div>
      </div>
    );

    return <div>{renderedView}</div>;
  }
}

CustomerActivity.propTypes = {};
export default CustomerActivity;
